const productDetailsConfig = {
  BASE_PRODUCT: "base",
  VARIANT_PRODUCT: "variant",
  ONE_SIZE: "ONE SIZE",
  NO_SIZE: "NO SIZE",
  INSTOCK: "available",
  OUTOFSTOCK: "out of stock",
  NOSIZESELECTED: "no size selected",
  GiftCardVariantProduct: "GiftCardVariantProduct",
}

export default productDetailsConfig
